import { SvgIcon } from '@material-ui/core';

export const IconChartBar = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M9.25 3a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1V3Zm3.5 1h-1.5v12h1.5V4ZM22 22H2v-2h20v2ZM3 10a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H3Zm1 6v-4h1.5v4H4Zm12.5-9a1 1 0 0 1 1-1H21a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1V7Zm3.5 9V8h-1.5v8H20Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
